<template>
  <ul class="root">
    <li class="item-root" v-for="(item, idx) in treeData" :key="idx" :depth="depth">
      <div :data-i="item.id" :data-type="item.type || ''" :data-key="item.key || ''" class="item form-check form-check-sm form-check-custom form-check-solid"
        :class="{'closed': item.closed, 'sel': item.selected, 'row-event-disable': disableRowEvent, 'd-none': !item.show}" 
        :style="{'padding-left': `${18 * (depth - 1) + 2}px`}"
        @click="clicked">
        <span class="item-toggle" @click="toggle">
          <a v-if="item.children && item.children.length" class="toggle btn btn-xxs btn-icon btn-circle btn-icon-dark btn-active-secondary">
            <i class="bi bi-caret-down-fill fs-8"></i>
          </a>        
        </span>
        <span class="item-check">
          <input v-if="showRadio" type="radio" :name="treeId" :id="item.compId" class="form-check-input" />
        </span>
        <label class="item-title" :for="item.compId" :title="item[labelKey]">
          <i v-if="item.icon" class="fs-4 bi" :class="item.icon"></i>
          <i v-else class="fs-4 bi bi-folder-fill text-primary"></i>
          <span class="item-label" v-text="item[labelKey]"></span>
          <i v-if="item.pwdExist" class="bi bi-lock-fill text-primary ms-2"></i>
        </label>
        <span v-if="customAction" class="item-action" v-html="customAction(item)"></span>
        <span v-else class="item-action">
          <a class="context-menu btn btn-xs btn-icon btn-circle btn-icon-dark btn-active-secondary" :title="$t('기능')">
            <i class="bi bi-three-dots-vertical fs-6"></i>
          </a>
        </span>
      </div>
      <TreeNodeView v-if="item.children"
        :treeData="item.children" :treeId="treeId" :labelKey="labelKey" :depth="depth + 1" 
        :showRadio="showRadio" :disableRowEvent="disableRowEvent"
        :customAction="customAction" @toggle="toggle" @clicked="clicked"></TreeNodeView>
    </li>
  </ul>
</template>

<script>
import TreeNodeView from "@/components/TreeNodeView.vue";

export default {
  components: { TreeNodeView },
  name: 'TreeNodeView',
  props: {
    treeData: Array,
    treeId: { default: () => '' },
    depth: { default: () => 1 },
    labelKey: { default: () => 'label' },
    showRadio: Boolean,
    disableRowEvent: Boolean,
    customAction: {},
  },
  methods: {
    toggle(evt) {
      evt.stopPropagation();
      return this.$emit('toggle', evt);
    },
    clicked(evt) {
      if(![...evt.target.classList].includes('form-check-input')) {
        return this.$emit('clicked', evt);
      }
    },
  },
}
</script>